import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import moment from 'moment';
import { dateFormattedWithUserLocale } from 'javascripts/util/dateFns';

export class EndDate extends Field {
  static attributesForModel() {
    return ['endDate'];
  }

  get title() {
    return 'End date';
  }

  exampleContents(): FieldContentsData {
    return {
      text: dateFormattedWithUserLocale(moment().add(3, 'months')),
      icon: { name: 'fa-regular fa-hourglass-end' },
    };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.endDate) {
      return {
        text: dateFormattedWithUserLocale(record.endDate),
        icon: { name: 'fa-regular fa-hourglass-end' },
      };
    }

    return {};
  }
}
